// tiptap extension
import Blockquote from '@tiptap/extension-blockquote'
import BulletList from '@tiptap/extension-bullet-list'
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import Dropcursor from '@tiptap/extension-dropcursor'
import FontFamily from '@tiptap/extension-font-family'
import Heading from '@tiptap/extension-heading'
import Highlight from '@tiptap/extension-highlight'
// import HorizontalRule from '@tiptap/extension-horizontal-rule'
import { Color } from '@tiptap/extension-color'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Subscript from '@tiptap/extension-subscript'
import Superscript from '@tiptap/extension-superscript'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import TaskItem from '@tiptap/extension-task-item'
import TaskList from '@tiptap/extension-task-list'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Typography from '@tiptap/extension-typography'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import { common, createLowlight } from './lowlight'

// custom extensions
import Commands from '../tools/commands/commands'
import MentionCommands from '../tools/commands/mentionCommands'
import { BookmarkExtension } from './bookmark'
import { CalloutExtension } from './callout'
import { ColumnExtension } from './column'
import { Details, DetailsContent, DetailsSummary } from './details'
import DragAndDrop from './dragAndDrop'
import { Hyperlink, previewHyperlinkModal, setHyperlinkModal } from './hyperlink'
import { ImageCustom } from './image-custom'
import { LoadingExtension } from './loading'
import { LinkToPage } from './page'
import { Placeholder } from './placeholder'
import { DocumentWithoutTitle } from './title'
import { ToggleExtension } from './toggle'
import Video from './video'
import { YoutubeExtension } from './youtube'
// import FocusClasses from './focus'
import Audio from './audio'
import FileHandler from './fileHandler'
import Separator from './separator'
import Table from './table'
import TrailingNode from './trailingNode'
import Mention from './userMention'

const lowlight = createLowlight()
lowlight.register(common)

const defaultExtension = [
  Audio,
  FileHandler,
  TrailingNode,
  Mention,
  MentionCommands,
  Separator,
  // FocusClasses,
  DragAndDrop,
  Hyperlink.configure({
    hyperlinkOnPaste: false,
    openOnClick: true,
    modals: {
      previewHyperlink: previewHyperlinkModal,
      setHyperlink: setHyperlinkModal,
    },
  }),
  Details,
  DetailsContent,
  DetailsSummary,
  DocumentWithoutTitle,
  BookmarkExtension,
  CalloutExtension,
  LoadingExtension,
  YoutubeExtension,
  ColumnExtension,
  ToggleExtension,
  ImageCustom,
  Dropcursor.configure({
    width: 3,
    color: '#BFE5F4',
    class: 'drop-cursor',
  }),
  FontFamily,
  LinkToPage,
  Typography,
  TextStyle,
  Underline,
  Commands,
  ListItem,
  TaskList,
  Color,
  Video,
  Table.configure({ resizable: true }),
  TableRow.extend({ allowGapCursor: true }),
  TableHeader.extend({ isolating: false }),
  TableCell.extend({ isolating: false }),
  CodeBlockLowlight.configure({ lowlight }),
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  StarterKit.configure({
    blockquote: false,
    bulletList: false,
    codeBlock: false,
    document: false,
    dropcursor: false,
    heading: false,
    history: false,
    horizontalRule: false,
    listItem: false,
    orderedList: false,
  }),
  Placeholder.configure({
    placeholder: ({ node, editor }) => {
      let text = "Write something … or type '/' to choose block"
      switch (node.type.name) {
        case 'heading':
          text = 'Heading'
          break
        case 'codeBlock':
          text = 'write code ...'
          break
        case 'tableCell':
          text = 'table cell'
          break
        case 'tableHeader':
          text = 'table header'
          break
        case 'blockquote':
          text = 'write quote ...'
          break
        case 'orderedList':
          text = 'text'
          break

        default:
          break
      }
      if (editor.isActive('table')) text = ''

      return text
    },

    emptyNodeClass: 'is-empty text--secondary',

    showOnlyCurrent: false,
    includeChildren: true,
  }),
  Heading.configure({
    levels: [1, 2, 3],
    HTMLAttributes: {
      class: 'heading',
    },
  }),
  OrderedList.configure({
    atom: true,
    isolating: true,
    content: '(inline|hardBreak?)*',
    HTMLAttributes: {
      class: 'orderedList',
    },
  }),
  TaskItem.configure({
    nested: true,
    HTMLAttributes: {
      class: 'todoList',
    },
  }),
  BulletList.configure({
    HTMLAttributes: {
      class: 'bulletedList',
    },
  }),
  Blockquote.configure({
    HTMLAttributes: {
      class: 'blockquote',
    },
  }),
  // HorizontalRule.configure({
  //   HTMLAttributes: {
  //     class: 'separator',
  //   },
  // }),
  Superscript.configure({
    HTMLAttributes: {
      class: 'superscript',
    },
  }),
  Subscript.configure({
    HTMLAttributes: {
      class: 'subscript',
    },
  }),
]

export default defaultExtension
